import { REQUEST_TYPES } from '../requestTypes';
import { defaultTableRequest, multilineChartRequest } from '../requestHelper';
import { ENTITY_NAMES } from '../entityNames';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const url = DASHBOARD_API_URLS.V2.KEYWORDS;
const chartUrl = DASHBOARD_API_URLS.V2.KEYWORDS_GRANULAR;

export const keywordsStatsRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_OVERVIEW_KEYWORDS]: multilineChartRequest(
        chartUrl,
        ENTITY_NAMES.OVERVIEW_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_OVERVIEW_AGENCY_KEYWORDS]: multilineChartRequest(
        chartUrl,
        ENTITY_NAMES.OVERVIEW_AGENCY_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_OVERVIEW_AGENT_KEYWORDS]: multilineChartRequest(
        chartUrl,
        ENTITY_NAMES.OVERVIEW_AGENT_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_TEAMS_KEYWORDS]: multilineChartRequest(
        chartUrl,
        ENTITY_NAMES.OVERVIEW_LOCATIONS_TEAMS_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_KEYWORDS]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCIES_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_AGENTS_KEYWORDS]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCY_AGENTS_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_KEYWORDS]: defaultTableRequest(
        url,
        ENTITY_NAMES.LOCATIONS_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_LOCATIONS_KEYWORDS]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCY_LOCATIONS_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_AGENTS_KEYWORDS]: defaultTableRequest(
        url,
        ENTITY_NAMES.LOCATIONS_AGENTS_KEYWORDS,
        ENDPOINTS.VF_DASHBOARD_URL
    )
};
